import state from './recordState'
import mutations from './recordMutations'
import getters from './recordGetters'
import actions from './recordActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
